import { useAuthentication } from '@zenbusiness/application-commons-authentication';
import { useIdentity } from '@zenbusiness/application-commons-identity';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

function UserInfo() {
  const { obo } = useAuthentication();
  const user = useIdentity();

  const fullName = `${user.firstName} ${user.lastName}`;
  const email = obo ? user.email : user.accountEmail;
  const name = obo ? `On behalf of ${fullName}` : fullName;

  return (
    <Stack gap={0.5} px={2} py={1}>
      <Text color="primary" size="xl" component="span" truncate weight="medium">
        {name}
      </Text>
      <Text color="secondary" size="sm" component="span" truncate>
        {email}
      </Text>
    </Stack>
  );
}

export default UserInfo;
